import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../../store';
import * as ConsoleStore from '../../../store/Console';
import './Applications.scss';
import QuickStart from './QuickStart';
import SupportTeam from './SupportTeam';
import Announcements from './Announcements';
import UserDashboards from '../UserDashboards';

type WelcomeProps = {} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class Welcome extends React.Component<WelcomeProps, any> {

    constructor(props: WelcomeProps) {
        super(props);
        this.props.consoleActions.getUserProfile();
    }

    public render() {
        return (
            <>
                <Container fluid className="d-flex flex-column main" style={{ "padding": "0.75rem" }}>
                    {this.props.console?.applicationsState.isLoading && (
                        <section className="text-center">
                            <FontAwesomeIcon icon={faSpinner} size="2x" spin={true} />
                        </section>
                    )}
                    <Row className="align-items-stretch mb-3 gx-0">
                        <Col xs={12}>
                            <Announcements></Announcements>
                        </Col>
                    </Row>
                    <Row className="align-items-stretch mb-3 gx-0">
                        <Col xs={12}>
                            <QuickStart></QuickStart>
                        </Col>
                    </Row>
                    <Row className="align-items-stretch mb-3 gx-0">
                        <Col xs={12}>
                            <UserDashboards></UserDashboards>
                        </Col>
                        <Col >
                            <SupportTeam></SupportTeam>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
